import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { PartnerStateService } from '../../services/partner-state.service';
import { PartnerStateEnum } from '../../services/partner-state.enum';
import { NotificationService } from '../../../general/services/notification.service';
import { NotificationType } from '../../../general/models/notification-type';

@Component({
  selector: 'app-partner-delete',
  templateUrl: './partner-delete.component.html',
  styleUrls: ['./partner-delete.component.css']
})
export class PartnerDeleteComponent implements OnInit, OnDestroy {

  currentPassword: string;

  agree: boolean;

  tooltipForwardError: string;

  @ViewChild(NgForm, {static: true}) form;

  constructor(
    private router: Router,
    private partnerStateService: PartnerStateService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
  }

  onAbort() {
    this.partnerStateService.update(PartnerStateEnum.ShowPartnerProfile);
  }

  onDelete() {
    if (!this.isFormValid) {
      return;
    }

    this.tooltipForwardError = '';

    this.partnerStateService.removeLoggedInPartner(this.currentPassword).subscribe(
      (result2: any) => {
        this.router.navigate(['/']);
      },
      (error) => {
        this.tooltipForwardError = error;
        this.notificationService.show(PartnerDeleteComponent.name, error, NotificationType.Error);
      }
    );
  }

  get isFormValid() {
    return this.form.valid && this.agree;
  }

  ngOnDestroy(): void {
    this.notificationService.hide(PartnerDeleteComponent.name);
  }
}
